module.exports = __webpack_public_path__ + "img/male.790f4320.svg";